import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, ArrowRight } from 'lucide-react';

const BlogCta = () => (
  <section className="py-16 md:py-24 bg-[#f7f4ec]" data-testid="blog-cta">
    <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8">
      <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-[#3D4A26] via-[#4a5b30] to-[#2d3a1a] p-10 md:p-16">
        {/* Decorative pattern */}
        <div className="absolute right-0 top-0 opacity-10 select-none pointer-events-none">
          <BookOpen size={280} className="text-white" strokeWidth={0.8} />
        </div>

        <div className="relative max-w-xl">
          <p className="text-[11px] uppercase tracking-[0.2em] font-semibold text-[#C8D843] mb-4">
            Blog & Rehber
          </p>
          <h2
            className="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-4"
            style={{ fontFamily: 'DM Sans, sans-serif' }}
          >
            Rota rehberlerimizden ilham alın.
          </h2>
          <p className="text-white/80 text-base md:text-lg leading-relaxed mb-8">
            Deneyimli rehberlerimizin kaleminden yürüyüş ipuçları, ekipman tavsiyeleri, tarih ve doğa hikâyeleri.
          </p>
          <a
            href="#magazine"
            data-testid="blog-cta-button"
            className="inline-flex items-center gap-2 bg-[#C8D843] text-[#1B1B1B] font-bold px-7 py-3.5 rounded-full text-sm hover:bg-white transition-colors duration-300"
          >
            Yazıları Keşfet
            <ArrowRight size={16} />
          </a>
        </div>
      </div>
    </div>
  </section>
);

export default BlogCta;
